module.exports = __webpack_public_path__ + "static/clients-accor.e44dae1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-accor.png
// module id = 927
// module chunks = 241767136424496